<template>
    <div :class="{ 'booking-widget--hide': !methods.length }" :id="'booking-widget-' + coachId">
        <div class="booking-widget__overlay" @click="activeBooking = false" v-if="showOverlay"></div>

        <div class="booking-widget" :class="{ 'booking-widget--on-top': activeBooking, 'booking-widget__new': isNewDesign, 'booking-widget--iframe': isInIframe }"
            v-click-outside="() => activeBooking = false" @click="activeBooking = true">
            <h2 v-if="!isListingPage" class="booking-widget__header"
                :class="{ 'booking-widget__header__new': isNewDesign }">
                {{ 'Book appointment online' | translate }}
            </h2>
            <h2 v-else @click="showWidgetInMobile = !showWidgetInMobile" class="booking-widget__header desktop-hide">
                {{ 'Available appointments' | translate }}
                <icon :name="showWidgetInMobile ? 'arrow-up' : 'arrow-down'" color="white"></icon>
            </h2>

            <div class="booking-widget__content"
                :class="{ 'mobile-hide': isListingPage && !showWidgetInMobile, 'booking-widget__content__new': isNewDesign }">
                <h3 class="booking-widget__title booking-widget__step-holder flex flex--v-center booking-widget__step-holder--active"
                    :class="{ 'booking-widget__title__new': isNewDesign }">
                    <span v-if="isNewDesign" class="booking-widget__step-tag booking-widget__step-tag__new">1</span>
                    <span v-else class="booking-widget__step-tag">Step 1</span>

                    {{ 'Choose treatment' | translate }}
                    <icon name="done" v-if="!rebook && isBookingSteps" :style="{ opacity: selectedMethod.id ? 1 : 0 }"
                        color="primary" :width="20"></icon>
                </h3>

                <method-dropdown :placeholder="'Choose a treatment' | translate" @select="setMethod"
                    :selected="selectedMethod" :currency="currency" :methods="methods">
                </method-dropdown>

                <div class="booking-widget__details" v-if="!isBookingSteps || selectedMethod.id"
                    :class="{ 'booking-widget__details--pending': !slotsReady, 'booking-widget__details__new': isNewDesign }">
                    <h3 class="booking-widget__title booking-widget__step-holder flex flex--v-center booking-widget__step-holder--active"
                        :class="{ 'booking-widget__title__new': isNewDesign }">
                        <span v-if="isNewDesign" class="booking-widget__step-tag booking-widget__step-tag__new">2</span>
                        <span v-else class="booking-widget__step-tag">Step 2</span>
                        {{ 'Choose time' | translate }}
                        <icon name="done" v-if="!rebook && isBookingSteps" :style="{ opacity: isSlotsReady ? 1 : 0 }"
                            color="primary" :width="20"></icon>
                    </h3>

                    <div v-if="!isNewDesign" class="booking-widget__multiple flex flex--v-center between-xs">
                        <span>{{ 'I want multiple appointments' | translate }}</span>
                        <switch-button v-model="multipleBookings"></switch-button>
                    </div>

                    <v-touch class="schedule-table__holder" @swiperight="previousDate" @swipeleft="nextDate"
                        :swipe-options="{ direction: 'horizontal' }">
                        <div class="schedule-table__previous" @click="previousDate()" v-if="currentDateIndex > 0">
                            <icon name="arrow-left" :width="24" color="dark-blue"></icon>
                        </div>

                        <div class="schedule-table__next" @click="nextDate()" v-if="nextFreeAppointment">
                            <icon name="arrow-right" :width="24" color="dark-blue"></icon>
                        </div>

                        <table class="schedule-table">
                            <caption class="schedule-table__title" :class="{ 'schedule-table__title__new': isNewDesign }">{{
                                getCurrentMonth() }}</caption>
                            <thead>
                                <tr>
                                    <th v-for="(slotsArray, weekDate, index) in slots" :key="weekDate"
                                        class="schedule-table__header" v-if="isShownDate(index)">
                                        <div class="schedule-table__slot-title"
                                            :class="{ 'schedule-table__slot-title--active': slotsArray.some(isSlotSelected) }">
                                            <div class="schedule-table__day">{{ getDay(weekDate) }}</div>
                                            <div class="schedule-table__date">{{ getDate(weekDate) }}</div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td v-for="(slotsArray, weekDate, index) in slots" :key="weekDate"
                                        class="schedule-table__slot-holder" v-if="isShownDate(index)">
                                        <ul class="schedule-table__slot-list">
                                            <li v-for="(slot, slotIndex) in slotsArray" :key="slot.time"
                                                v-if="isShowSlot(slotIndex)" class="schedule-table__slot-item">
                                                <span class="schedule-table__slot-select"
                                                    :class="{ 'schedule-table__slot-select--active': isSlotSelected(slot), 'schedule-table__slot-select__new': isNewDesign, }"
                                                    v-scroll-to.center="'proceed-to-checkout-' + coachId"
                                                    @click.stop="setSlot(slot)" v-if="isBookingSteps">{{ getTime(slot.time)
                                                    }}</span>
                                                <span v-else class="schedule-table__slot-select" :class="{
                                                        'schedule-table__slot-select--active': isSameTime(slot),
                                                        'schedule-table__slot-select--multiple': multipleBookings,
                                                        'schedule-table__slot-select--disabled': isSlotConflicts(slot),
                                                        'schedule-table__slot-select__new': isNewDesign,
                                                        'schedule-table__slot-select--multiple__new': multipleBookings && isNewDesign,
                                                    }" @click.stop="setSlot(slot)">{{ getTime(slot.time) }}</span>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="flex center-xs schedule-table__all-slots-holder" v-if="isShowMoreButton">
                            <span class="schedule-table__all-slots"
                                :class="{ 'schedule-table__all-slots__new': isNewDesign }" @click="toggleSlots()">{{
                                    moreButtonTranslateKey | translate }}</span>
                        </div>
                        <div class="flex center-xs schedule-table__all-slots-holder" v-if="!isAppointmentsSeen">
                            <span class="schedule-table__next-appointment" v-if="nextFreeAppointment"
                                @click="nextDate(nextFreeAppointment)">{{ 'Next appointment' | translate }}: <strong>{{
                                    getNextDate(nextFreeAppointment) }}</strong></span>
                            <span class="schedule-table__no-next-appointment" v-else>{{ 'No more dates available' |
                                translate }}</span>
                        </div>
                    </v-touch>

                    <div v-if="isNewDesign"
                        class="booking-widget__multiple booking-widget__multiple__new flex flex--v-center between-xs">
                        <span>{{ 'I want multiple appointments' | translate }}</span>
                        <switch-button v-model="multipleBookings" :is-new-design="isNewDesign"></switch-button>
                    </div>

                </div>

                <div :class="{ 'pt-15': isSlotsReady }" v-if="!rebook && isBookingSteps"
                    :id="'proceed-to-checkout-' + coachId">
                    <button class="button button--medium button--secondary" :class="{ hide: !isSlotsReady }"
                        @click="activateFinalStep">
                        {{ 'Proceed to checkout' | translate }}
                    </button>
                </div>

                <div class="end-xs" :class="{ 'pt-15': multipleBookings }" v-if="!rebook && multipleBookings"
                    :id="'proceed-to-checkout-' + coachId">
                    <button class="button button--small button--uppercase button--mwa button--dark-blue posr"
                        :class="{ 'button--grey': isNewDesign }" :disabled="finalSlots.length === 0"
                        @click="activateFinalStep">
                        {{ 'Next' | translate }}
                        <icon name="arrow-right-2" :width="24" color="white"></icon>

                        <span class="booking-widget__multiple-bookings-badge"
                            :class="{ 'booking-widget__multiple-bookings-badge__new': isNewDesign }"
                            v-if="multipleBookings && finalSlots.length > 0">{{ finalSlots.length }}</span>
                    </button>
                </div>
            </div>
        </div>

        <modal v-if="showFinalStepModal" :is-in-iframe="isInIframe" modal-style="redesign" :container-style="successStepStyle" :is-new-design="isNewDesign" @close="closeModal">
            <div slot="header"></div>
            <div slot="body">
                <div class="wg-container" v-if="!paymentSuccessStep">
                    <bk-header
                        :name="fullCoachName"
                        :slots="finalSlots"
                        :price="selectedMethod.price"
                        :currency="currency"
                        :image="coachPhotoUrl"
                        :get-related-method="getRelatedMethod"
                        :get-time="getTime"
                    />
                </div>

              <div class="wg-container">
                <health-advisor-form v-if="!paymentSuccessStep"
                    :customer="customer"
                    :closeModal="closeModal"
                    :onSubmit="handleSlotSubmit"
                    :isTelephoneInvalid="isTelephoneInvalid"
                    :allowedPaymentMethods="allowedPaymentMethods"
                    :errorMessage="bookingErrorMessage"
                    :is-new-design="isNewDesign"
                />
                <div v-else class="flex flex--col gap">
                    <confirm-reservation
                        :customer-email="this.customer.email"
                        :slots="paymentSuccessData.booking"
                        :therapist="paymentSuccessData.therapist"
                    />
                    <div class="conf-footer flex">
                        <button-rd @click.native="closeModal" variant="primary">{{ "Finish" | translate }}</button-rd>
                    </div>
                </div>

              </div>
            </div>
            <div slot="footer"></div>
        </modal>

        <div class="booking-widget__fully-booked" v-if="showFullyBookedLabel">
            {{ 'Fully booked' | translate }}
        </div>

        <div class="booking-widget__few-appointments" v-if="showFewAppointmentsLabel">
            {{ 'Only a few appointments left' | translate }}
        </div>

        <transition name="booking-widget__almost-ready">
            <div v-if="showAlmostReadyLabel" class="booking-widget__almost-ready desktop-hide">
                {{ 'Almost ready. Two more steps to booking' | translate }}
            </div>
        </transition>

        <div class="booking-widget__arrow-section mobile-hide hide" v-if="showArrowSectionDiv">
            <div class="booking-widget__arrow-text" :class="'booking-widget__arrow-text--' + lang" />
            <img class="booking-widget__arrow" alt="" src="../../assets/img/pic/arrow-up.png" />
        </div>

        <spinner class="spinner--fullscreen" :class="{'spinner--light': isInIframe}" :show="confirmPending"></spinner>

        <button class="booking-widget__sticky-cta desktop-hide" type="button" v-scroll-to="'booking-widget-' + coachId"
            v-if="showCTA && isWidgetScrolled && !rebook" @click="onStickyButtonClick">{{ 'Book appointment' | translate
            }}</button>
    </div>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { get as getValue, throttle } from "lodash";
import moment from 'moment-timezone';
import Datepicker from 'vuejs-datepicker';
import { emailRegexp, nameRegexp, phoneRegexp } from '../../constants/customerInfo';
import ClickOutside from '../../directives/ClickOutside';
import ScrollTo from '../../directives/ScrollTo';
import store from '../../store/index';
import Icon from '../icon/Icon';
import MethodDropdown from '../method-dropdown/MethodDropdown';
import Modal from '../modal/Modal';
import SelectBox from '../select-box/SelectBox';
import Spinner from '../spinner/Spinner';
import SwitchButton from '../switch-button/SwitchButton';
import VueTelInput from '../vue-tel-input/VueTelInput.vue';
import BkHeader from "./Header.vue";
import HealthAdvisorForm from "./HealthAdvisorForm.vue";
import ConfirmReservation from "./ConfirmReservation.vue";

const SLOT_WIDTH_PX = 87;
const DEFAULT_DATES_PER_PAGE = 4;
const MAX_DATES_PER_PAGE = 6;
const MAX_TIME_SLOTS = 5;
const DEFAUL_CURRENCY = 'CHF';

var dataLayer = window.dataLayer || [];

export default {
    name: 'health-advisor-widget',
    components: {
      HealthAdvisorForm,
      BkHeader,
      VueTelInput,
      Icon,
      SwitchButton,
      Modal,
      SelectBox,
      Spinner,
      MethodDropdown,
      Datepicker,
      ConfirmReservation,
    },
    directives: {
        ScrollTo,
        ClickOutside
    },
    data() {
        return {
            isBookingAvailable: true,
            isInited: false,
            isAlmostReadyLabel: false,
            multipleBookings: false,
            isBookingSteps: false, // TODO: enable when will be ready
            newWindow: {},
            selectedMethod: {},
            slotsReady: false,
            selectedSlot: {},
            selectedSlots: [],
            currentDateIndex: 0,
            datesPerPage: DEFAULT_DATES_PER_PAGE,
            slots: {},
            isShowAllSlots: false,
            finalStep: false,
            fullName: '',
            showWidgetInMobile: false,
            customer: {
                email: this.email,
                firstname: this.firstname,
                lastname: this.lastname,
                telephone: this.telephone,
                country: '',
                countryCode: '',
                paymentMethod: this.invoice ? 'invoice' : this.creditCard && !this.local ? 'credit_card' : 'local',
                bookingUrl: this.bookingUrl,
                coach_firstname: this.coachFirstname,
                coach_lastname: this.coachLastname,
                coach_street: this.coach_street,
                coach_postcode: this.coach_postcode,
                coach_city: this.coach_city,
                slug: this.slug,
            },
            user_comment: '',
            promo_code: '',
            isSubmitted: false,
            activeBooking: false,
            showCTA: this.isCoachProfile,
            isWidgetScrolled: false,
            profile: null,
            services: [],
            methods: [],
            confirmPending: false,
            currency: DEFAUL_CURRENCY,
            urlToOpen: '',
            paymentSuccessStep: false,
            paymentSuccessData: {},
            bookingErrorMessage: '',
            didPushHistoryState: false,
        }
    },
    props: {
        therapistId: {
            type: [String, Number],
            default: ''
        },
        praxisId: {
            type: [String, Number],
            default: ''
        },
        locationId: {
            type: [String, Number],
            default: ''
        },
        profilePhoto: {
            type: String,
            default: ''
        },
        coachPhotoUrls: {
            type: Array,
            default() {
                return [];
            }
        },
        slug: {
            type: String,
            default: ''
        },
        coachId: {
            type: Number,
            default: -1
        },
        fullCoachName: {
            type: String,
            default: ''
        },
        firstname: {
            type: String,
            default: store.state.search.CF.user_firstname || ''
        },
        lastname: {
            type: String,
            default: store.state.search.CF.user_lastname || ''
        },
        email: {
            type: String,
            default: store.state.search.CF.user_email || ''
        },
        telephone: {
            type: String,
            default: store.state.search.CF.user_telephone || ''
        },
        local: {
            type: Boolean,
            default: false
        },
        invoice: {
            type: Boolean,
            default: false
        },
        creditCard: {
            type: Boolean,
            default: false
        },
        channel: {
            type: String,
            default: 'cf'
        },
        isCoachSite: {
            type: Boolean,
            default: false
        },
        isCoachProfile: {
            type: Boolean,
            default: false
        },
        isListingPage: {
            type: Boolean,
            default: false
        },
        coach_firstname: {
            type: String,
            default: ''
        },
        coach_lastname: {
            type: String,
            default: ''
        },
        coach_street: {
            type: String,
            default: ''
        },
        coach_postcode: {
            type: String,
            default: ''
        },
        coach_city: {
            type: String,
            default: ''
        },
        coach_url: {
            type: String,
            default: ''
        },
        max_time_slots: {
            type: Number,
            default: MAX_TIME_SLOTS
        },
        hideOverlay: {
            type: Boolean,
            default: false
        },
        rebook: {
            type: Boolean,
            default: false
        },
        showArrowSection: {
            type: Boolean,
            default: false
        },
        isScarcityLabel: {
            type: Boolean,
            default: false
        },
        isNewDesign: {
            type: Boolean,
            default: false
        },
        isInIframe: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentProfile() {
            // If we are in search list of coaches – use local copy
            if (this.profile) {
                return this.profile;
            }
            // fallback – store (coach detail page)
            return store.state.healthAdvisorProfile;
        },
        agreeMessageHTML() {
            let linkTermsAndConditions = `<a href="https://www.sanasearch.ch/agb/" target="_blank" rel="noopener noreferrer">${this.$options.filters.translate('Terms and Conditions')}</a>`;
            let linkPrivacyPolicy = `<a href="https://www.sanasearch.ch/datenschutz/" target="_blank" rel="noopener noreferrer">${this.$options.filters.translate('Privacy Policy')}</a>`;
            return this.$options.filters.translate(
                `With your booking you agree to the {0} and {1} of Sanasearch.`,
                [linkTermsAndConditions, linkPrivacyPolicy]
            );
        },
        confirmationTitle() {
            const full_name = this.paymentSuccessData.therapist.full_name;
            let title = `Thank you very much for your booking with {0}! Your reservation has been successfully confirmed.`;
            return this.$options.filters.translate(title, [full_name]);
        },
        contactTitle() {
            return this.$options.filters.translate('Contacts data of the therapist');
        },
        phoneInfoText() {
            return this.$options.filters.translate('We need your phone number to send you an appointment reminder before the appointment');
        },
        commentInfoText() {
            return this.$options.filters.translate('This message can only be read by the therapist. After the booking you will receive the full contact information of the therapist including the phone number if you have any further questions');
        },
        moreButtonTranslateKey() {
            return this.isShowAllSlots ? 'Show less' : 'Show more';
        },
        coachPhotoUrl() {
            return this.profilePhoto || this.coachPhotoUrls[0];
        },
        showOverlay() {
            return !this.hideOverlay && this.activeBooking && !this.isCoachSite && !this.rebook && !this.finalStep;
        },
        isSlotsReady() {
            return this.multipleBookings ? this.selectedSlots.length > 0 : !!(this.selectedSlot && this.selectedSlot.time);
        },
        finalSlots() {
            return [...(this.multipleBookings ? this.selectedSlots : [this.selectedSlot])].sort((a, b) => moment(a.time) - moment(b.time));
        },
        selectedMethodsPriceSumm() {
            return (this.finalSlots.reduce((summ, slot) => summ + parseFloat(this.getRelatedMethod(slot).price), 0)).toFixed(2);
        },
        showFinalStepModal() {
            return this.finalStep && this.isSlotsReady && !this.rebook;
        },
        isAppointmentsSeen() {
            const slotsDates = Object.keys(this.slots);
            const shownArray = slotsDates.slice(this.currentDateIndex, this.currentDateIndex + this.datesPerPage);

            return shownArray.some(date => this.slots[date].length);
        },
        isShowMoreButton() {
            const slotsDates = Object.keys(this.slots);
            const shownArray = slotsDates.slice(this.currentDateIndex, this.currentDateIndex + this.datesPerPage);

            return shownArray.some(date => (this.slots[date].length > this.max_time_slots));
        },
        nextFreeAppointment() {
            const slotsDates = Object.keys(this.slots);
            const shownArray = slotsDates.slice(this.currentDateIndex);

            let nextDate = shownArray.filter(date => this.slots[date].length)[0] || '';

            return nextDate;
        },
        confirmationData() {
            return this.multipleBookings ? {
                payload: this.selectedSlots.map(this.getBookingData)
            } : this.getBookingData(this.selectedSlot);
        },
        isEmailInvalid() {
            return this.isSubmitted && !emailRegexp.test(this.customer.email);
        },
        isFirstnameInvalid() {
            return this.isSubmitted && !nameRegexp.test(this.customer.firstname);
        },
        isLastnameInvalid() {
            return this.isSubmitted && !nameRegexp.test(this.customer.lastname);
        },
        isTelephoneInvalid() {
            return this.isSubmitted && !phoneRegexp.test(this.customer.telephone);
        },
        isFormReady() {
            return emailRegexp.test(this.customer.email) &&
                nameRegexp.test(this.customer.firstname) &&
                nameRegexp.test(this.customer.lastname) &&
                phoneRegexp.test(this.customer.telephone)
        },
        purchaseId() {
            return this.slug + '_' + moment().format('YYYY-MM-DD_HH:mm');
        },
        isCreditCardChecked() {
            return this.customer.paymentMethod.value === 'credit_card';
        },
        isLocalChecked() {
            return this.customer.paymentMethod.value === 'local';
        },
        isInvoiceChecked() {
            return this.customer.paymentMethod.value === 'invoice';
        },
        lang() {
            return store.state.lang;
        },
        showScarcityLabel() {
            return store.state.search.CF.showScarcityLabel === null ? this.isScarcityLabel : store.state.search.CF.showScarcityLabel;
        },
        showFullyBookedLabel() {
            return this.showScarcityLabel && this.isCoachProfile && this.slotsReady && !this.isAvailableWithinFourDays && !this.isAppointmentsSeen;
        },
        showFewAppointmentsLabel() {
            return this.showScarcityLabel && this.isCoachProfile && this.isAvailableWithinFourDays && this.isAppointmentsSeen && this.fewAppointmentsLeft;
        },
        showAlmostReadyLabel() {
            return this.isCoachProfile && this.isAlmostReadyLabel;
        },
        isAvailableWithinFourDays() {
            if (!Object.values(this.slots).length) {
                return false;
            }
            if (this.nextFreeAppointment) {
                let viewingDate = moment().startOf('day').add(this.currentDateIndex, 'days');
                return moment(this.nextFreeAppointment).add(1, 'seconds').isBetween(moment(viewingDate), moment(viewingDate).add(3, 'days').endOf('day'));
            }
            return false;
        },
        fewAppointmentsLeft() {
            let appointments = Object.values(this.slots);
            let slotNumber = 0;
            const MAX_FEW = 4;
            for (let i = this.currentDateIndex; i < this.currentDateIndex + this.datesPerPage; i++) {
                for (let j = 0; j < appointments[i].length; j++) {
                    slotNumber++;
                    if (slotNumber > MAX_FEW) {
                        return false;
                    }
                }
            }

            return true;
        },
        showArrowSectionDiv() {
            return this.showArrowSection && !this.showFullyBookedLabel && !this.showFewAppointmentsLabel;
        },
        coachFirstname() {
            return this.coach_firstname || this.fullCoachName.split(' ')[0];
        },
        coachLastname() {
            return this.coach_lastname || this.fullCoachName.split(' ')[1];
        },
        allowedPaymentMethods() {
            const paymentMethods = [];

            if (this.creditCard) paymentMethods.push('credit_card');
            if (this.local) paymentMethods.push('local');
            if (this.invoice) paymentMethods.push('invoice');
            console.log(paymentMethods);

            return paymentMethods;
        },
        iconColor() {
            if (this.isNewDesign) {
                return '#555555';
            }
            return 'primary';
        },
        successStepStyle() {
          if (this.paymentSuccessStep) {
            return 'm-container__lg'
          } else {
            return ''
          }
        }
    },
    created() {
        // if (this.rebook) {
        //     this.restoreSelectedSlot();
        // }

        //populate from localStorage
        // const customerInfo = this.getCustomerInfo();
        // if (customerInfo) {
        //     for (let prop in customerInfo) {
        //         if (this.customer[prop] && !customerInfo[prop]) continue;
        //         if (prop === 'paymentMethod' && !this.allowedPaymentMethods.includes(customerInfo[prop])) continue;
        //
        //         this.customer[prop] = customerInfo[prop];
        //     }
        // }
        localStorage.removeItem('customerInfo');

        this.fullName = this.customer.firstname + ' ' + this.customer.lastname;

        this.$root.$on('activateBookingFinalStep', this.activateBookingFinalStep);

        this.$root.$on('SET_SCARCITY_LABEL', (newValue) => {
            store.commit('SET_SCARCITY_LABEL', newValue);

            if (!this.showScarcityLabel && !this.isAppointmentsSeen && this.nextFreeAppointment) {
                this.nextDate(this.nextFreeAppointment);
            }
        });

        if (this.isCoachProfile) {
            setTimeout(() => { this.isAlmostReadyLabel = true }, 5000);
        }

        document.addEventListener('scroll', this.handlerOnScroll);
        document.body.addEventListener('scroll', this.handlerOnScroll);
        window.addEventListener("resize", this.updateDatesPerPage);
    },
    beforeDestroy: function () {
        document.removeEventListener('scroll', this.handlerOnScroll);
        document.body.removeEventListener('scroll', this.handlerOnScroll);
        window.removeEventListener("resize", this.updateDatesPerPage);
    },
    mounted() {
        this.updateDatesPerPage();
        this.initDataFetch();
    },
    watch: {
        coachId(newId) {
          if (!newId) {
            return;
          }

          this.isInited = false;
          this.initDataFetch();
        },

        urlToOpen() {
            if (this.urlToOpen && this.urlToOpen.includes("https://")) {
                window.location.href = this.urlToOpen;
            }
        },
        activeBooking() {
            this.showCTA = false;
        },
        fullName(newValue) {
            const names = newValue.trim().split(' ');

            this.customer.lastname = names.length > 1 ? names.pop() : '';
            this.customer.firstname = names.join(' ');
        },
        multipleBookings(newValue) {
            if (newValue && !this.selectedSlots.length && this.selectedSlot.time) {
                this.selectedSlots.push(this.selectedSlot);
            }

            if (!newValue && this.selectedSlots.length && !this.selectedSlot.time) {
                this.selectedSlot = this.selectedSlots[0];
            }
        }
    },
    methods: {
        handleSlotSubmit(data) {
          const {
            first_name,
            last_name,
            email,
            telephone,
            country,
            countryCode,
            paymentMethod,
            message,
          } = data

          this.customer.firstname = first_name
          this.customer.lastname = last_name
          this.customer.email = email
          this.customer.telephone = telephone
          this.customer.country = country
          this.customer.countryCode = countryCode
          this.customer.paymentMethod = paymentMethod
          this.customer.user_comment = message
          this.applyFinalStep()

        },
        getBookingData(slot) {
            var preparedSlot = this.prepareHealthAdvisorSlot(slot);
            return {
                slug: this.slug,
                coach_id: this.coachId,
                is_fake: false,
                slot: preparedSlot,
                customer: {
                    email: this.customer.email,
                    firstname: this.customer.firstname,
                    lastname: this.customer.lastname,
                    telephone: this.customer.telephone
                },
                channel: this.channel,
                payment: {
                    method: this.customer.paymentMethod.value,
                    price: this.getRelatedMethod(preparedSlot).price
                },
                user_comment: this.customer.user_comment,
                promo_code: "-",
                treatment: this.selectedMethod.name,
                duration: this.selectedMethod.duration,
                source_url: window.location.href,
            };
        },
        getPaymentMethod() {
            var choosenPaymentMethod;
            if (this.isLocalChecked) {
                choosenPaymentMethod = this.$options.filters.translate('Local');
            } else if (this.isCreditCardChecked) {
                choosenPaymentMethod = this.$options.filters.translate('Online payment');
            } else if (this.isInvoiceChecked) {
                choosenPaymentMethod = this.$options.filters.translate('Invoice');
            } else {
                choosenPaymentMethod = '-';
            }
            return `${this.$options.filters.translate('Payment method')}: ${choosenPaymentMethod}\n\n`;
        },
        getClientFullName(firstname, lastname) {
            return `${this.$options.filters.translate('Customer')}: ${firstname} ${lastname}\n\n`;
        },
        // getVoucher(code) {
        //     const template = this.$options.filters.translate('Voucher code');
        //     if (code) {
        //         return `${template}: ${code}\n\n`;
        //     }
        //     return `${template}: -\n\n`;
        // },
        getUserMessage(userComment) {
            const template = this.$options.filters.translate('Personal message');
            if (userComment) {
                return `${template}: ${userComment}\n`;
            }
            return `${template}: -\n`;
        },
        getComment() {
            return this.getClientFullName(this.customer.firstname, this.customer.lastname) +
                this.getPaymentMethod() +
                this.getUserMessage(this.customer.user_comment);
        },
        prepareHealthAdvisorSlot(slot) {
            const comment = this.getComment();
            const country = this.customer.country;
            const countryCode = this.customer.countryCode;
            let phoneNumber = this.customer.telephone;
            if (this.customer.telephone.startsWith(countryCode)) {
                phoneNumber = phoneNumber.replace(countryCode, '');
            }
            slot = {
                treatmentId: slot.treatmentIds[0],
                ...slot
            }
            const result = {
                profile: this.currentProfile,
                treatmentIds: slot.treatmentIds,
                slots: [slot],
                patient: {
                    firstName: this.customer.firstname,
                    lastName: this.customer.lastname,
                    email: this.customer.email,
                    mobile: {
                        country,
                        countryCode,
                        number: phoneNumber,
                    }
                },
                termsAndConditionsConfirmed: true,
                // We don't support sms validation, we use health advisor plugin for that
                verificationRequest: { token: "" },
                prescriptionsMetadata: [],
                comment: comment,
                payment_method_type: this.customer.paymentMethod,
            }
            return result;
        },
        getCustomerInfo() {
            let customerInfo = null;

            try {
                customerInfo = JSON.parse(localStorage.getItem('customerInfo'));
            } catch (error) {
                console.log('Cant get customerInfo from object in localStorage');
            }

            return customerInfo;
        },
        updateDatesPerPage() {
            const newValue = Math.floor(this.$el.parentElement.clientWidth / SLOT_WIDTH_PX) || DEFAULT_DATES_PER_PAGE;

            this.datesPerPage = Math.min(newValue, MAX_DATES_PER_PAGE);
        },
        elementIsScrolled() {
            let el = this.$el;
            let top = el.offsetTop;
            const DELTA_PX = 500;

            while (el.offsetParent) {
                el = el.offsetParent;
                top += el.offsetTop;
            }

            return (top - DELTA_PX) <= (window.pageYOffset + window.innerHeight);
        },
        initDataFetch() {
            if (this.isInited) return;
            if (!this.elementIsScrolled()) return;

            this.isInited = true;

            store.dispatch('LOAD_HEALTH_ADVISOR_PROFILE', this.coachId)
              .then(() => {
                const profile = store.state.healthAdvisorProfile;
                this.profile = profile;  // local copy

                this.methods = profile.treatments || [];
                if (!this.methods.length) {
                  return;
                }

                this.methods.sort((a, b) => a.sortCode - b.sortCode);
                this.setMethod(this.methods[0]);

                if (this.isDialogOpen()) {
                  this.activateBookingFinalStep();
                }
              });
        },
        isDialogOpen() {
            return window.location.href.indexOf('status=termin-buchen') > -1;
        },
        activateBookingFinalStep() {
            this.restoreSelectedSlot();

            if (!this.selectedSlot || !this.selectedSlot.combinations) return;

            if (this.methods.length) {
                const method = this.methods.filter(item => item.id === this.selectedSlot.combinations[0].services[0])[0];

                this.setMethod(method);
            }

            this.activateFinalStep();
        },
        restoreSelectedSlot() {
            if (localStorage.getItem('selectedSlot')) {
                this.selectedSlot = JSON.parse(localStorage.getItem('selectedSlot'));
            }
        },
        getMethods() {
            const allMethodsId = this.services.map(({ _id }) => _id);
            const methods = [/*{
                    id: allMethodsId.join(',')
                }*/];

            this.services.forEach(({ name, price, duration, _id }) => {
                price = Number(price).toFixed(2);

                methods.push({ name, price, duration, id: _id });
            });

            return methods;
        },
        setMethod(method) {
          if (!method || !method.id) {
            return;
          }

          if (this.selectedMethod === method) return;

          this.selectedSlot = this.selectedMethod.id ? {} : this.selectedSlot;
          this.selectedSlots = this.selectedMethod.id ? [] : this.selectedSlots;
          this.selectedMethod = method;

          this.slotsReady = false;
          this.currentDateIndex = 0;

          this.getFreeSlots(method.id);

          if (this.rebook) {
            this.$emit('rebookMethodSelected', method);
            this.$emit('rebookTimeSlotSelected', {});
          }
        },
        getRelatedMethod(slot) {
            const method = this.methods.filter(item => item.id === slot.treatmentIds[0])[0];

            return method || {};
        },
        getFreeSlots(treatmentId) {
            const start = moment().format('YYYY-MM-DD');
            const end = moment().add(6, 'months').format('YYYY-MM-DD');

            store.dispatch('LOAD_HEALTH_ADVISOR_SLOTS', { treatmentId, userId: this.coachId })
                .then((response) => {
                    const treatmentSlots = response[0]["slots"];

                    treatmentSlots.forEach((slot, index) => {
                      const slotKey = moment.utc(slot.start).format('YYYY-MM-DD');
                      const timeValue = moment.utc(slot.start).format();
                      this.slots[slotKey] = this.slots[slotKey] || []
                      this.slots[slotKey].push({ ...slot, time: timeValue })
                    });

                    // TODO: Commented out - this code was removing slots from the last available date,
                    // causing dates like Feb 5th to not show when API returns slots for Feb 4th and 5th.
                    // Original purpose unclear - possibly to hide incomplete data for the last day?
                    // let keysWithSlots = Object.keys(this.slots).filter(key => this.slots[key].length > 0)
                    // if (keysWithSlots.length > 1) {
                    //     this.slots[keysWithSlots[keysWithSlots.length - 1]] = []
                    // }

                    this.slotsReady = true;
                    this.showCTA = true;
                    this.$root.$emit('WIDGET_HEIGHT_CHANGE');

                }, (error) => {
                    console.log("Cant get free appointments");
                });

            this.slots = {
                ...this.slots,
                ...this.getEmptyDays(start, end),
            };
        },
        getEmptyDays(from, to) {
            const emptyDates = {};
            const fromDate = moment(from);
            const toDate = moment(to);

            while (fromDate.diff(toDate, 'days') <= 0) {
                emptyDates[fromDate.format('YYYY-MM-DD')] = [];
                fromDate.add(1, 'days');
            }

            return emptyDates;
        },
        setSlot(slot) {
            if (this.multipleBookings) {
                if (this.isSlotConflicts(slot)) return;

                const index = this.getIndexOfSlotSelected(slot);

                if (index === -1) {
                    this.selectedSlots.push(slot);
                } else {
                    this.selectedSlots.splice(index, 1);
                }
            } else {
                this.selectedSlot = slot;
            }

            if (!this.rebook) {
                this.removeCustomerInfo();
                if (!this.isBookingSteps && !this.multipleBookings) this.activateFinalStep();

                dataLayer.push({
                    'event': 'dl-interaction',
                    'event-cat': 'coach',
                    'event-action': `time slot click`,
                    'event-label': window.location.pathname
                });
            } else {
                this.$emit('rebookTimeSlotSelected', slot);
            }

        },
        removeSelectedSlot(slot) {
            const index = this.selectedSlots.indexOf(slot);

            this.selectedSlots.splice(index, 1);
        },
        removeSlotOnSuccess() {
            let dateTimeString = this.selectedSlot.time;
            let dateString = dateTimeString.split("T")[0];
            let availableSlots = this.slots[dateString];
            availableSlots = availableSlots.filter(item => item.time != dateTimeString);
            this.slots[dateString] = availableSlots;
        },
        toggleSlots() {
            this.isShowAllSlots = !this.isShowAllSlots;

            this.$root.$emit('WIDGET_HEIGHT_CHANGE');
        },
        isShowSlot(slotIndex) {
            return this.isShowAllSlots ? true : slotIndex < this.max_time_slots;
        },
        isSameTime(slot) {
            return (this.multipleBookings ? this.selectedSlots : [this.selectedSlot])
                .some(item => item.time === slot.time);
        },
        getIndexOfSlotSelected(slot) {
            return (this.multipleBookings ? this.selectedSlots : [this.selectedSlot])
                .reduce((index, item, currentIndex) => {
                    const itemService = getValue(item, 'treatmentIds[0]');
                    const slotService = getValue(slot, 'treatmentIds[0]');

                    return (item.time === slot.time &&
                        itemService === slotService) ? currentIndex : index;
                }, -1);
        },
        isSlotSelected(slot) {
            return this.getIndexOfSlotSelected(slot) > -1;
        },
        isSlotConflicts(slot) {
            return this.multipleBookings && !this.isSlotSelected(slot) && this.selectedSlots.some(item => {
                const itemStart = getValue(item, 'start');
                const itemEnd = getValue(item, 'end');
                const slotStart = getValue(slot, 'start');
                const slotEnd = getValue(slot, 'end');

                return itemStart === slotStart ||
                    itemEnd === slotEnd ||
                    moment(itemEnd).isBetween(slotStart, slotEnd) ||
                    moment(slotEnd).isBetween(itemStart, itemEnd);
            });
        },
        getDay(date) {
            return moment(date).format('dd');
        },
        getDateAndMonth(date) {
            return moment.utc(date).format('D MMMM');
        },
        getDate(date) {
            return moment(date).format('D');
        },
        getNextDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },
        getTime(date) {
            return moment.utc(date).tz('Europe/Zurich').format('HH:mm');
        },
        getCurrentMonth() {
            let date = Object.keys(this.slots)[this.currentDateIndex];
            let lastDate = Object.keys(this.slots)[this.currentDateIndex + this.datesPerPage - 1];


            date = moment(date).format('MMMM YYYY');
            lastDate = moment(lastDate).format('MMMM YYYY');

            return date === lastDate ? date : date + ' - ' + lastDate;
        },
        activateFinalStep() {
            if (!this.isSlotsReady) return;

            this.finalStep = true;
            if (!this.isDialogOpen()) {
                if (this.coach_url) {
                    window.history.pushState(null, null, this.getOpenModalLink());
                } else {
                    window.history.replaceState(null, null, window.location.href.split("?")[0]);
                    window.history.pushState(null, null, window.location.pathname + '?status=termin-buchen');
                }
                this.didPushHistoryState = true;
            }
            window.addEventListener('popstate', this.stateHandler, false);
        },
        getOpenModalLink() {
            const thisPage = window.location.href;
            const symbol = /\?$/.test(thisPage) ? '' : /\?.+/.test(thisPage) ? '&' : '?';

            return thisPage + symbol + 'status=termin-buchen';
        },
        stateHandler(event) {
            this.closeModal(event);
        },
        isShownDate(index) {
            return index >= this.currentDateIndex && index < (this.currentDateIndex + this.datesPerPage);
        },
        previousDate() {
            const result = this.currentDateIndex - this.datesPerPage;

            this.currentDateIndex = result < 0 ? 0 : result;
        },
        nextDate(nextDate) {
            const slotDates = Object.keys(this.slots);
            const nextDateIndex = slotDates.indexOf(nextDate);

            const maxIndex = slotDates.length - this.datesPerPage;
            const result = nextDateIndex > -1 ? nextDateIndex : this.currentDateIndex + this.datesPerPage;

            this.currentDateIndex = result >= maxIndex ? maxIndex : result;
        },
        applyFinalStep() {
            this.isSubmitted = true;

            if (!this.isFormReady) return;

            dataLayer.push({
                'event': 'dl-interaction',
                'event-cat': 'coach',
                'event-action': `termin buchen click`,
                'event-label': window.location.pathname
            });

            this.confirmPending = true;

            this.removeCustomerInfo();

            store.dispatch('CONFIRM_BOOKING', this.confirmationData).then((result) => {
                if (result && result.success) {
                    this.urlToOpen = result.checkout_url;
                } else {
                    this.confirmPending = false;
                    this.bookingErrorMessage = 'We are sorry, this appointment has already been booked in the meantime.';
                    this.isBookingAvailable = false;
                }
            }).then(() => {
                if (!this.urlToOpen.includes("https://") && this.urlToOpen) {
                    store.dispatch('SUCCESS_PAYMENT', this.urlToOpen).then((response) => {
                        this.paymentSuccessStep = true;
                        this.paymentSuccessData = response;
                        this.confirmPending = false;
                        this.removeSlotOnSuccess();
                    }).finally(() => {
                        this.confirmPending = false;
                        this.getFreeSlots(this.selectedMethod.id);
                    });
                }
            });
            dataLayer.push({'event': 'booking-event'});
        },
        removeCustomerInfo() {
            localStorage.removeItem('customerInfo');
            localStorage.removeItem('selectedSlot');
        },
        redirectToPage(checkoutUrl) {
            if (checkoutUrl) {
                if (this.isCoachSite) {
                    this.newWindow = window.open();

                    this.newWindow.location.href = checkoutUrl;

                    this.removeSlotOnSuccess();

                    this.resetBooking();
                } else {
                    window.location.href = checkoutUrl;

                    this.confirmPending = true;
                }

                return;
            }

            window.history.replaceState(null, null, window.location.pathname + '?status=thank-you');

            this.removeSlotOnSuccess();
        },
        closeModal(onGoBack) {
            if (!this.finalStep) return;

            this.finalStep = false;

            if (!onGoBack && this.didPushHistoryState) {
                window.history.back();
            }

            this.didPushHistoryState = false;

            if (!this.coach_url) {
                window.history.replaceState(null, null, window.location.href.split("?")[0]);
            }

            window.removeEventListener('popstate', this.stateHandler, false);

            this.$nextTick(() => {
                this.activeBooking = false;
            });

            if (!Event) return;

            if (!this.isBookingAvailable) {
                this.getFreeSlots(this.selectedMethod.id);
            }

            this.isBookingAvailable = true;
            this.paymentSuccessStep = false;
            this.paymentSuccessData = {};
            this.urlToOpen = '';
            this.resetBooking();
        },
        resetBooking() {
            this.finalStep = false;
            // this.selectedMethod = {};
            // this.slotsReady = false;
            this.selectedSlot = {};
            this.selectedSlots = [];
            this.isShowAllSlots = false;
            this.isSubmitted = false;
            this.isBookingAvailable = true;
            this.bookingErrorMessage = '';
        },
        getCoachProfileUrl() {
            return this.coach_url || window.location.href;
        },
        saveCustomerToLocalStorage() {
            this.customer.bookingUrl = this.getCoachProfileUrl().split('/fachperson/')[1];
            this.customer.coach_firstname = this.coachFirstname;
            this.customer.coach_lastname = this.coachLastname;
            this.customer.coach_street = this.coach_street;
            this.customer.coach_postcode = this.coach_postcode;
            this.customer.coach_city = this.coach_city;
            this.customer.slug = this.slug;
        },
        setFirstname(event) {
            this.customer['firstname'] = event.target.value;
        },
        setLastname(event) {
            this.customer['lastname'] = event.target.value;
        },
        setFullName(fullName) {
            const names = fullName.trim().split(' ');

            this.customer.lastname = names.length > 1 ? names.pop() : '';
            this.customer.firstname = names.join(' ');
        },
        setEmail(event) {
            this.customer['email'] = event.target.value;
        },
        setUserComment(event) {
            this.customer['user_comment'] = event.target.value;
        },
        setPromoCode(event) {
            this.customer['promo_code'] = event.target.value;
        },
        setPaymentMethod(event) {
            this.customer['paymentMethod'] = event.target.value;
        },
        onStickyButtonClick() {
            this.activeBooking = true;
        },
        handlerOnScroll: throttle(function () {
            this.initDataFetch();

            if (!this.$el || !this.$el.getBoundingClientRect) return;

            const offsetTop = this.$el.getBoundingClientRect().top;

            this.isWidgetScrolled = offsetTop < 0;

            if (this.isInited && (!this.isCoachProfile || this.isWidgetScrolled)) {
                document.removeEventListener('scroll', this.handlerOnScroll);
                document.body.removeEventListener('scroll', this.handlerOnScroll);
            }
        }, 70)
    }
}
</script>

<style lang="less">
@import "../../less/variables.less";

@booking-widget-border-radius: 8px;

//   @font-face {
//     font-family: 'Museo Sans', sans-serif;
//     src: url('https://fonts.cdnfonts.com/css/museo-sans-rounded');
//   }

.wg-container {
  padding: 24px;
}

.m-container__lg {
  max-width: 960px !important;
  .modal-cancel .icon {
    display: none !important;
  }
}

.spinner--light {
    background-color: rgba(255, 255, 255, .7);
}

[id^="booking-widget-"] {
    padding: 20px;
}

.booking-widget {
    &--iframe {
        border: none !important;
        border-radius: @booking-widget-border-radius;
        box-shadow: @box-shadow;

        .booking-widget {

            &__header {
                border-top-left-radius: @booking-widget-border-radius;
                border-top-right-radius: @booking-widget-border-radius;
            }

            &__content {
                border-bottom-left-radius: @booking-widget-border-radius;
                border-bottom-right-radius: @booking-widget-border-radius;
            }
        }
    }
}

.booking-widget {
    position: relative;
    z-index: 50;
    background: white;
    border: 1px solid #f0f0f0;
    max-width: 600px;
    margin: 0 auto;

    &__new {
        border: none !important;
    }

    &--on-top {
        z-index: 55;
    }

    .fixed-header .modal-open & {
        z-index: 10;
    }

    &--hide {
        >div {
            opacity: 0;
            z-index: -1;
        }
    }

    &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 40;
    }

    &__header {
        font-size: 1.35rem;
        line-height: 1.6rem;
        font-weight: 700;
        padding: 15px;
        margin: 0 !important;
        text-align: center;
        text-transform: uppercase;
        background: @dark-blue-3;
        color: white;
        border-bottom: 1px solid @light-grey;

        &__new {
            background: #f0f0f0;
            color: #555555;
        }
    }

    &__content {
        padding: 20px 17px 18px;
        background: white;

        &__new {
            padding: 15px 0 !important;
        }
    }

    &__title {
        font-size: 1.125rem;
        line-height: 1.5rem;
        font-weight: 500;
        text-align: center;
        margin: 0 0 20px;

        &__new {
            margin: 0;
            background: #e0e1e2;
            color: #555555 !important;
            padding: 20px;
            justify-content: center;
        }
    }

    &__step {
        &-holder {
            position: relative;
            color: @dark-blue;

            &__new {
                color: #555555;
            }
        }

        &-tag {
            display: none;
            position: absolute;
            left: -17px;
            top: 50%;
            transform: translate(0, -50%);
            padding: 4px 6px;
            background: @primary;
            color: #fff;
            font-size: 1rem;
            line-height: 20px;
            font-weight: 600;
            text-transform: uppercase;

            &:after {
                content: '';
                position: absolute;
                top: 50%;
                transform: translate(0, -50%);
                left: 100%;
                height: 0;
                width: 0;
                border-top: 14px solid transparent;
                border-bottom: 14px solid transparent;
                border-left: 14px solid @primary;
            }

            &__new {
                left: 0;
                padding: 4px 10px;
                background: #f0f0f0;
                color: #555555;
                border-radius: 0 50% 50% 0;

                &:after {
                    content: none;
                }
            }
        }

        @media @viewport-md-up {
            &-holder--active {
                //   padding-left: 72px;
                text-align: left;
                font-weight: 600;
                color: @primary;

                &__new {
                    color: #555555;
                }
            }

            &-holder--active &-tag {
                display: block;
            }
        }
    }

    &__details {
        padding-top: 20px;

        &__new {
            padding-top: 15px;
        }

        &--pending {
            opacity: 0.4;
        }
    }

    &__multiple {
        padding: 10px 17px;
        background: @greyee;
        margin: 0 -17px 15px;

        &__new {
            margin: 0;
            background: #f0f0f0;
        }

        &-bookings-badge {
            min-width: 10px;
            padding: 3px 7px;
            font-size: 12px;
            font-weight: bold;
            line-height: 1;
            vertical-align: middle;
            white-space: nowrap;
            text-align: center;
            border-radius: 10px;
            background-color: darken(@primary, 10%);
            color: #fff;
            position: absolute;
            top: -10px;
            right: -11px;

            &__new {
                background-color: #555555;
            }
        }
    }

    &__next-step {
        margin-left: auto;
        min-width: 110px;
    }

    @media screen and (max-width: 767px) {
        &__header {
            font-size: 1rem;
            padding: 8px;
        }

        &__content {
            padding: 17px 13px 18px;
            background: white;
        }

        &__multiple {
            padding: 10px 13px;
            margin: 0;

            &__new {
                margin: none;
            }
        }

        &__title {
            font-size: 1rem;
            line-height: 1.5rem;
            margin: 0 0 15px;

            &__new {
                margin: none;
            }
        }

        &__details {
            padding-top: 15px;
        }

        &__next-step {
            height: 30px;
            padding: 6px;
            font-size: 0.75rem;
            line-height: 1rem;
            min-width: 70px;
        }
    }

    &__sticky-cta {
        position: fixed;
        z-index: 1001;
        left: 0;
        bottom: 0;
        display: block;
        width: 100%;
        padding: 20px;
        font-size: 1.25rem;
        line-height: 1.75rem;
        color: #fff;
        background: @secondary;
        border: none;
        margin: 0;
        outline: none;
    }

    &__arrow-section {
        margin-top: 10px;
        position: relative;

        @media screen and (max-width: 1455px) {
            display: none;
        }
    }

    &__arrow-text {
        width: 433px;
        height: 95px;

        &--en {
            background: url(../../assets/img/pic/arrow-text-en.png) no-repeat 0 0;
        }

        &--de {
            background: url(../../assets/img/pic/arrow-text-de.png) no-repeat 0 0;
        }
    }

    &__arrow {
        position: absolute;
        right: -60px;
        bottom: 38px;
    }

    &__fully-booked {
        margin-top: 1rem;
        width: 100%;
        text-align: center;
        background-color: @light-red;
        color: @red;
        font-size: 0.875rem;
        font-weight: 600;
        border: 1px solid @red;
        text-transform: uppercase;
        line-height: 2.5rem;
        letter-spacing: 1px;

        @media screen and (max-width: 1199px) {
            display: none;
        }
    }

    &__few-appointments {
        margin-top: 1rem;
        width: 100%;
        text-align: center;
        background-color: @light-orange;
        color: @secondary;
        font-size: 0.875rem;
        font-weight: 600;
        border: 1px solid @secondary;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
        letter-spacing: 1px;

        @media screen and (min-width: 1200px) and (max-width: 1599px) {
            font-size: 0.75rem;
            padding: 0.5rem;
        }
    }

    &__almost-ready {
        margin-top: 1rem;
        width: 100%;
        text-align: left;
        color: @secondary;
        font-size: 0.875rem;
        line-height: 1.125rem;
        font-weight: 600;
        padding: 0.5rem;

        &-enter-active,
        &-leave-active {
            transition: opacity .5s;
        }

        &-enter,
        &-leave-to {
            opacity: 0;
        }
    }
}

.schedule-table {
    width: 100%;
    height: 15px;
    border-collapse: collapse;
    border-left: 1px solid @light-grey-4;

    &__holder {
        position: relative;
        border-bottom: 1px solid @light-grey-4;
        margin: 0;

        &:after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            width: 1px;
            background-color: @light-grey-4;
        }
    }

    &__previous,
    &__next {
        position: absolute;
        top: 42px;
        padding: 20px 3px;
        font-size: 0;
        line-height: 0;
        cursor: pointer;
    }

    &__previous {
        left: -14px;
        margin-left: 2.4%;
    }

    &__next {
        right: -14px;
        margin-right: 2.4%;
    }

    &__all-slots {
        color: @primary;
        text-decoration: none;
        cursor: pointer;
        padding: 20px 32px;
        font-weight: 600;
        display: inline-block;

        &__new {
            color: #555555;
        }

        &:hover {
            text-decoration: underline;
        }
    }

    &__next-appointment {
        cursor: pointer;
        padding: 20px 32px;
        display: inline-block;
        background: @light-grey-3;
        color: @dark-grey;
        margin: 7px 0;
        font-size: 0.875rem;
        line-height: 1.25rem;

        &:hover {
            background: shade(@light-grey-3, 10%);
        }
    }

    &__no-next-appointment {
        padding: 15px;
        display: inline-block;
        background: @light-grey-3;
        color: @dark-grey;
        margin: 7px 0;
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    &__all-slots-holder {
        border-left: 1px solid @light-grey-4;
        background: white;
        margin-top: -15px;
        width: 100%;
    }

    &__title {
        background: @light-grey-4;
        color: @dark-blue;
        font-size: 1.25rem;
        line-height: 1.4rem;
        font-weight: 600;
        padding: 10px;
        text-align: center;
        position: relative;
        z-index: 1;

        &__new {
            color: #555555;
            background: white;
            border: 1px solid #e2e2e2;
        }
    }

    &__header {
        background: #fff;
        border-left: 1px solid @light-grey-4;
        border-bottom: 1px solid @light-grey-4;
        padding: 0;
        width: 1%;
        min-width: 68px;
        text-align: center;
    }

    &__slot-title {
        display: inline-block;
        padding: 14px;
        min-width: 48px;
        font-weight: 600;
        color: @dark-grey;

        &--active {
            background: @dark-grey;
            color: white;

            &__new {
                background: #555555;
            }
        }
    }

    &__day {
        font-size: 0.75rem;
        line-height: 1.1rem;
    }

    &__date {
        font-size: 1rem;
        line-height: 1.1rem;
    }

    &__slot-holder {
        padding: 0;
        vertical-align: top;
        text-align: center;
        border-left: 1px solid @light-grey-4;
    }

    &__slot-list {
        margin: 0;
        padding: 10px 5px 15px;
        list-style: none;
    }

    &__slot-item {
        &+& {
            margin-top: 10px;
        }
    }

    &__slot-select {
        padding: 8px;
        border: 2px solid transparent;
        display: inline-block;
        background: @primary;
        color: #fff;
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1.25rem;
        max-width: 70px;
        width: 100%;
        cursor: pointer;

        &:not(&--disabled):hover {
            background: @dark-blue;
            color: white;
        }

        &__new {
            background: white;
            border: 2px solid #e0e1e2;
            color: #555555;

            &:not(&--disabled):hover {
                background: #555555;
                color: #e0e1e2;
            }
        }

        &--active {
            background: transparent;
            color: @dark-blue;
            border-color: @dark-blue;

            &:hover {
                background: transparent;
                color: @dark-blue;
            }

            &__new {
                color: #555555;
                border-color: #555555;

                &:hover {
                    background: transparent;
                    color: #555555;
                }
            }
        }

        &--disabled {
            opacity: 0.7;
            cursor: not-allowed;
        }

        &--active&--multiple {
            position: relative;

            &__new {
                &:before {
                    content: '';
                    position: absolute;
                    right: -7px;
                    top: -7px;
                    height: 16px;
                    width: 16px;
                    background: #555555 !important;
                    border-radius: 50%;
                    box-shadow: 0 0 2px -0.5px white;
                }
            }

            &:before {
                content: '';
                position: absolute;
                right: -7px;
                top: -7px;
                height: 16px;
                width: 16px;
                background: @dark-blue;
                border-radius: 50%;
                box-shadow: 0 0 2px -0.5px white;
            }

            &:after {
                content: "";
                z-index: 1;
                position: absolute;
                right: -4px;
                top: -3px;
                height: 5px;
                width: 9px;
                border-width: 0 0 2px 2px;
                border-style: solid;
                border-color: white;
                transform-origin: center;
                overflow: hidden;
                -moz-transform: scale(1) rotate(-45deg);
                -webkit-transform: scale(1) rotate(-45deg);
                transform: scale(1) rotate(-45deg);
            }
        }
    }

    @media @viewport-xs {
        &__holder {
            margin: 0;
        }

        &__previous,
        &__next {
            top: 42px;
            padding: 20px 0;
        }

        &__previous {
            left: -10px;
        }

        &__next {
            right: -10px;
        }

        &__all-slots {
            font-size: 0.875rem;
            line-height: 1.125rem;
            padding: 19px 19px 18px;
        }

        &__all-slots-holder {
            margin-top: -10px;
        }

        &__slot-title {
            padding: 15px 12px 14px;
            min-width: 0;
        }

        &__day {
            font-size: 0.75rem;
            line-height: 1rem;
        }

        &__date {
            font-size: 0.75rem;
            line-height: 1rem;
        }

        &__slot-holder {
            padding: 0;
            vertical-align: top;
            text-align: center;
            border-left: 1px solid @light-grey-4;
        }

        &__slot-list {
            margin: 0;
            padding: 7px 4px 10px;
            list-style: none;
        }

        &__slot-item {
            &+& {
                margin-top: 7px;
            }
        }

        &__slot-select {
            padding: 5px 6px;
            font-size: 0.75rem;
            line-height: 1.25rem;
            min-width: 0;
        }
    }
}

.svg-success {
    stroke-width: 2px;
    stroke: #8EC343;
    fill: none;
    vertical-align: middle;
}

.appointment {
    &__holder {
        align-items: center;
        background: @light-grey-3;
        margin-bottom: 50px;
    }

    &__item+&__item {
        padding-top: 10px;
    }

    &__group {
        align-items: center;
    }

    &__image {
        background-position: 50% 50%;
        background-size: cover;
        margin-right: 45px;

        img {
            max-width: 100%;
            max-height: 140px;
            vertical-align: middle;
        }
    }

    &__title {
        margin: 0;
        color: @dark-grey;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 3rem;
        text-align: left;
    }

    &__method {
        min-width: 38%;
        text-align: left;
    }

    &__method-details {
        margin: 0;
        font-size: 1.125rem;
        line-height: 2rem;
        color: @dark-grey;
        position: relative;
    }

    &__duration {
        min-width: 90px;
        padding: 0 15px;
    }

    &__cost {
        min-width: 100px;
    }

    &__cancel {
        position: absolute;
        cursor: pointer;
        margin-left: 10px;
        left: 100%;
        top: 5px;
        border: 1px solid @dark-blue;
        font-size: 0;
        line-height: 0;
    }

    &__date {
        color: white;
        background: @primary;
        min-width: 20%;
    }

    &__date-grey {
        color: white;
        background: #555555;
        min-width: 20%;
    }

    &__date-item {
        margin: 0;
        padding: 19px 24px;
        font-size: 1.5rem;
        line-height: 2rem;
        color: white;

        &+& {
            position: relative;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 1px;
                background: @light-grey;
            }
        }
    }

    &__date-icon {
        margin-right: 12px;
    }

    &__totals-holder {
        margin: -15px 0 25px;
        border: 2px solid @primary;
        background: fade(@primary, 5%);
        color: @primary;
        padding: 15px;
    }

    &__totals-holder-grey {
        margin: -15px 0 25px;
        border: 2px solid #555555;
        background: fade(#555555, 5%);
        color: #555555;
        padding: 15px;
    }

    &__totals-item {
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: 600;
    }

    &__totals-summ {
        font-weight: 700;
        font-size: 1.4rem;
        line-height: 1.8rem;
    }

    @media screen and (max-width: 767px) {
        &__holder {
            margin-bottom: 23px;
        }

        &__item {
            display: block;
        }

        &__group {
            align-items: flex-start;
        }

        &__image {
            overflow: hidden;
            max-width: 42%;
            margin-right: 10px;

            img {
                max-width: none;
                position: relative;
                left: 50%;
                transform: translate(-50%, 0);
            }
        }

        &__title {
            margin: 0 0 8px;
            color: @dark-grey;
            font-size: 1.25rem;
            line-height: 1.5rem;
        }

        &__method {
            padding: 11px 5px;
            min-width: 54%;
        }

        &__method-details {
            display: block;
            font-size: 0.875rem;
            line-height: 2rem;
            font-weight: 600;
        }

        &__cancel {
            margin-left: 0;
            left: auto;
            right: 0;
            top: -10px;
        }

        &__totals-holder {
            margin: -10px 0 15px;
            padding: 10px;
        }

        &__method-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        &__duration {
            padding: 0;
        }

        &__date {
            margin-left: 0;
            display: flex;
        }

        &__date-item {
            margin: 0;
            padding: 12px 10px 12px 3px;
            font-size: 0.875rem;
            line-height: 2rem;

            &+&:before {
                bottom: 0;
                right: auto;
                height: auto;
                width: 1px;
            }
        }

        &__date-icon {
            transform: scale(0.7);
            margin-right: 2px;
        }
    }
}

.booking-form {
    text-align: left;

    &__title {
        font-size: 1.5rem;
        line-height: 1.75rem;
        margin: 0 0 23px;
        font-weight: 500;
    }

    &__sub-title {
        margin: 0 0 23px;
        color: @primary;
        font-size: 1.125rem;
        line-height: 1.5rem;
    }

    &__card-icons {
        background: url(../../assets/img/icons/credit-card-icons.png) no-repeat 0 0;
        background-size: cover;
        width: 126px;
        height: 26px;
    }

    input&__input {
        display: block;
        width: 100%;
        font-size: 1.125rem;
        line-height: 1.5rem;
        padding: 9px 18px;
        color: #444448;

        &--full {
            height: 40px;
            background: @light-grey-3;
            border: 1px solid @light-grey-3;
        }

        &--border {
            height: auto;
            background: #fff;
            border: 1px solid @grey;
        }
    }

    &__label-grey {
        display: block;
        margin-bottom: 5px;
        color: #555555;

        &--required:after {
            content: ' *';
            color: #555555;
        }
    }

    &__label {
        display: block;
        margin-bottom: 5px;
        color: @dark-blue;

        &--required:after {
            content: ' *';
            color: @primary;
        }
    }

    &__terms {
        color: @dark-blue;
        font-size: 0.975rem;
        line-height: 1.25rem;
    }

    &__terms-grey {
        a {
            font-weight: bold;
            color: #555555;
        }

        a:hover {
            text-decoration: underline;
        }

        font-size: 0.975rem;
        line-height: 1.25rem;
    }

    &__info-label {
        color: @primary;
        font-size: 0.975rem;
        line-height: 1.25rem;
    }

    &__info-sign {
        position: absolute;
        z-index: 10;
        top: 10px;
        left: 100%;
        margin-left: 1px;
        cursor: pointer;
    }

    &__help-holder {
        position: relative;
    }

    &__help-info {
        position: absolute;
        top: 50%;
        font-size: 0;
        line-height: 0;
        right: 12px;
        transform: translate(0, -50%);
    }

    &__help-tooltip {
        position: absolute;
        top: -99999px;
        left: -99999px;
        opacity: 0;
        width: 330px;
        margin-bottom: 14px;
        font-size: 1rem;
        line-height: 1.25rem;
        background: #fff;
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.2);


        @media screen and (max-width: 579px) {
            width: 270px;
        }

        &-corner {
            position: absolute;
            top: 100%;
            right: 0;
            height: 30px;
            width: 100%;
            overflow: hidden;

            &:after {
                content: '';
                position: absolute;
                width: 15px;
                height: 15px;
                background: #fff;
                transform: rotate(45deg) translate(-70%, 0);
                top: 0;
                right: 10px;
                box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
            }
        }
    }

    &__help-info:hover &__help-tooltip {
        top: auto;
        left: auto;
        ;
        bottom: 100%;
        right: -12px;
        opacity: 1;
    }

    &__field--has-error {
        border-color: @red !important;
        color: @red !important;

        &::placeholder {
            color: @red !important;
        }
    }

    &__error-message {
        padding-top: 4px;
        margin-bottom: -22px;
        font-size: 0.9375rem;
        line-height: 1.125rem;
        color: transparent;

        &--show {
            color: @red;
        }
    }

    &__comment {
        min-height: 105px;
        border: 1px solid @greyd8;
        font-size: 1.125rem;
        line-height: 1.5rem;
        padding: 12px;
        resize: vertical;
        max-height: 300px;

        &:hover {
            border-color: @grey;
        }

        &:focus {
            border-color: @primary;
        }
    }

    &__submit {
        font-size: 1.125rem;
        line-height: 1.5rem;
    }

    &__navigation {
        flex-direction: row-reverse;
    }

    @media @viewport-md-up {
        &__aside {
            padding-left: 23px;
        }
    }

    @media screen and (max-width: 767px) {
        &__title {
            font-size: 1.25rem;
            line-height: 1.75rem;
            margin: 0 0 21px;
        }

        input&__input {
            font-size: 1rem;
        }

        &__error-message {
            padding-top: 2px;
            font-size: 0.875rem;
            margin-bottom: -8px;
        }

        &__navigation {
            flex-direction: column;

            .button {
                display: block;
                height: 35px;
                padding: 6px;

                &+.button {
                    margin-top: 10px;
                }
            }
        }

        &__comment {
            min-height: 100px;
        }
    }
}

.button--grey {
    background: #555555;
}

//   .checked {
//     background: #555555;
//     color: #555555;
//   }

.checked:before {
    border-color: #555555 !important;
}

.checked:after {
    background-color: #555555 !important;
}

.button--close--blue {
    background-color: #47d7e0;
}

.text-left {
    text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/health-advisor-widget/HealthAdvisorWidget.vue